<div class="container main-container ">

    <!--==============Main Middle Start==============-->
    <div class="main-middle">
      
    
        <!--............Post Input..............-->
       

        <div class="container0">
            <div class="row" style="border-radius: 20px; ">
                <form action="" class="add-post" >
                    <div class="add-post-row" (click)="onCreatePostClick()">
                        <div class="profile-picture" id="my-profile-picture">
                            <img [src]="profilePhotoUrl" alt="">
                        </div>
                        <div class="publier">Publiez une photo sonore...</div>
                        
                        <!--<input type="submit" value="Publier" class="btn btn-primary" (click)="onCreatePostClick()">-->
                        <div class="voice-record-btn">
                          <button class="record-btn" >
                            <i class="fa fa-microphone"></i> <!-- Icône d'enregistrement -->
                          </button>
                        </div>
                        
                    </div>
                </form>
            </div>
        </div>
        
        <!--............Post Input..............-->
        <br>
        <div>
            <div id="post-feed">
                
                <app-post *ngFor="let post of posts" [postData]="post" (messageUser)="onMessageUser($event)" (videoPlayed)="onVideoPlayed($event)"></app-post>
                
                <!-- Trigger pour le défilement infini -->
                <div #loadMoreTrigger id="infinite-scroll-trigger" class="d-flex justify-content-center my-4">
                    <ng-container *ngIf="!allLoaded; else allLoadedTpl">
                        <div *ngIf="loading" class="spinner">
                            <div class="bounce1"></div>
                            <div class="bounce2"></div>
                            <div class="bounce3"></div>
                        </div>
                    </ng-container>
                    <ng-template #allLoadedTpl>
                        <div class="text-center text-muted">
                            <p>Vous avez vu toutes les vidéos</p>
                        </div>
                    </ng-template>
                </div>
            </div>        
        </div>
    </div>
    <!--==============Main Middle End==============-->
    
    <!--==============Main Right Start==============-->
<div class="main-right">
    <div class="messages">
        
        <div class="discussion-instantane">
            <h5>Espace Publicité</h5> 
        </div>
    
        <div class="message-search-bar">
            <!--<i class="fa fa-search"></i>-->
            <!--<input type="search" placeholder="Search message" id="message-search">-->
        </div>
        
        <div class="message-categories">
            <!--<button style="width: 100%;">
                <div class="row">
                    <div class="row">
                        <div class="profile-picture col-3">
                            <img src="https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c" alt="">
                        </div>
                        <h5 class="col-6 mt-2 ml-0"><button>Prenom Nom</button></h5>
                        <button style="width: 40px; color: rgb(55, 172, 245);">Suivre</button>
                    </div>             
                </div>
            </button>-->
            <!--<h6 class="active">Primaire</h6>
            <h6>General</h6>
            <h6 class="message-request">Demande(2)</h6>-->
        </div>

        <!--<button style="width: 100%;">
            <div class="row">
                <div class="row">
                    <div class="profile-picture col-3">
                        <img src="https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c" alt="">
                    </div>
                    <h5 class="col-6 mt-2 ml-0"><button>Prenom Nom</button></h5>
                    <button style="width: 40px; color: rgb(55, 172, 245);">Suivre</button>
                </div>             
            </div>
        </button>-->
    </div>

    <br>

    <hr style="border: 1px solid black;">
    <br>
    <div class="firend-request">
        <h4 class="discussion-instantane">Mes contacts</h4>
        <p class="mx-4" style="color: gray; font-size: 14px;">Les personnes que vous suivez et qui vous suivent en retour </p>
        <div class="chat-sidebar">
            <div *ngFor="let user of mutualFollowers" (click)="openChatWindow(user)"   class="chatRow">
                
                
                    <div class="row  my-1" >
                        <img [src]="user.profilePhotoUrl" alt="{{user.publicName}}" class="profile-picture2 col-2">
                        <span class="col-9 my-2 ml-0">{{user.publicName}}</span>
                    </div>
                
              
            </div>
          </div>

          <!-- Fenêtres de chat -->
        <div class="chat-windows">
            <div *ngFor="let chatWindow of openChats" class="chat-window">
            <div class="chat-header">
                <div class="chatInfo">
                    <img [src]="chatWindow.userData.profilePhotoUrl" alt="{{chatWindow.userData.publicName}}" class="profile-picture2 col-2">
                    <div>
                        <div >{{chatWindow.userData.publicName}}</div>
                        <div ><small style="color: gray;">({{chatWindow.userData.description}})</small></div>
                    </div>
                </div>
                
                <button (click)="closeChatWindow(chatWindow.userData)" class="close-button">X</button> <!-- Bouton pour fermer la fenêtre -->
            </div>
            <!--<div class="chat-messages">
                <div *ngFor="let message of messages">
                  <span [ngClass]="{'my-message': message.senderId === currentUser.id}">
                    {{message.text}}
                  </span>
                </div>
              </div>-->

              <div class="chat-messages" #messageContainer (scroll)="checkIfScrolledToBottom(chatWindow, messageContainer)">
                <div *ngFor="let message of chatWindow.messages; let i = index" class="chat-message">
                  <span [ngClass]="{'sent': message.senderId === userData.uid, 'received': message.senderId !== userData.uid}">{{ message.text }}</span>
                  
                  <span [ngClass]="{'sentAt': message.senderId === userData.uid, 'receivedAt': message.senderId !== userData.uid}"><small >{{ message.timestamp | date:'shortTime' }}</small></span>
                </div>
              </div>
            <div class="chat-input">
                <textarea [(ngModel)]="chatWindow.newMessage" 
                    class="message-input" 
                    placeholder="Écrire un message..." 
                    id="messageInput"
                    wrap="soft"
                    rows="4"
                    (keydown)="handleKeydown($event, chatWindow, messageContainer)">
                </textarea>
                
                <button class="send-button" (click)="sendMessage(chatWindow, i)">
                    <img src = "../../../assets/images/img/paper-plane2.png" class="envelope-icon">
                    <i class="envelope-icon"></i>
                  </button>
               <!-- Bouton pour envoyer le message -->
            </div>
            </div>
        </div>
        <!--<button style="width: 100%;">
            <div class="row">
                <div class="row">
                    <div class="profile-picture col-3">
                        <img src="https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c" alt="">
                    </div>
                    <h5 class="col-6 mt-2 ml-0">Prenom Nom</h5>
                </div>             
            </div>
        </button>
        <button style="width: 100%;">
            <div class="row">
                <div class="row">
                    <div class="profile-picture col-3">
                        <img src="https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c" alt="">
                    </div>
                    <h5 class="col-6 mt-2 ml-0">Prenom Nom</h5>
                </div>             
            </div>
        </button>

        <button style="width: 100%;">
            <div class="row">
                <div class="row">
                    <div class="profile-picture col-3">
                        <img src="https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c" alt="">
                    </div>
                    <h5 class="col-6 mt-2 ml-0">Prenom Nom</h5>
                </div>             
            </div>
        </button>

        <button style="width: 100%;">
            <div class="row">
                <div class="row">
                    <div class="profile-picture col-3">
                        <img src="https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c" alt="">
                    </div>
                    <h5 class="col-6 mt-2 ml-0">Prenom Nom</h5>
                </div>             
            </div>
        </button>

        <button style="width: 100%;">
            <div class="row">
                <div class="row">
                    <div class="profile-picture col-3">
                        <img src="https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c" alt="">
                    </div>
                    <h5 class="col-6 mt-2 ml-0">Prenom Nom</h5>
                </div>             
            </div>
        </button>
        -->

        <div class="contact-container" *ngIf="mutualFollowers.length <6">
            <div class="contact-circle">
              
              <img src="https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/lenali.png?alt=media&token=ae3e0c00-4c03-492b-9a5a-444fd11c4e60" alt="">
              
            </div>
            <div class="contact-items">
              <div class="contact-item">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
              </div>
              <div class="contact-item">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                </svg>
              </div>
              <div class="contact-item">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"/>
                </svg>
              </div>
              <div class="contact-item">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                </svg>
              </div>
            </div>
          </div>
        
        
        
        
    </div>
    
</div>
<!--==============Main Right End==============-->
    </div>
